import { createFileRoute } from '@tanstack/react-router'
import { Layers3 } from 'lucide-react'
import { z } from 'zod'
import { ProjectionsScreen } from '@/screens/engine/SCR-011-projections'

export const Route = createFileRoute('/_app/w/$ws/projections')({
  staticData: { screen: { id: 'SCR-011', title: 'Projections', group: 'Workspace', perm: 'projection.manage', order: 11, eyebrow: 'Versioned views of memory', description: 'The views built from the event log: their generation, how far behind they are, and rebuilding them safely.', icon: Layers3 } },
  validateSearch: z.object({
    tab: z.enum(['projections', 'channels']).optional().catch(undefined),
  }),
  component: ProjectionsScreen,
})
